// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"declineBountyContest-module--carouselContainer--39ceA","carouselGraphic3":"declineBountyContest-module--carouselGraphic3--1UeZA"};